module.exports = __webpack_public_path__ + "media/images/athletes/2877-d16de0d045701bb36d7e43cfd2666a75.png";